var map = {
	"./files/files.json": 1568,
	"./items/HintPackages.json": 6542,
	"./items/HintPackages_translations.json": 9726,
	"./items/dialogue_messages.json": 8667,
	"./items/dialogue_messages_translations.json": 7142,
	"./items/text.json": 5943,
	"./items/text_translations.json": 5680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6657;